import ProductDetailedPage from '../../../bps/components/productDetailedPage/productDetailedPage';
import productStore from '../../../bps/stores/product/ProductStore';

export default class ProductDetailedPageHaw extends ProductDetailedPage {
  contentSections: HTMLElement[];

  constructor(mainElement, name = 'product-detailed-page') {
    super(mainElement, name);

    this.contentSections = Array.from(document.querySelectorAll('.product-details__section--contents'));
  }

  onVariationChange() {
    const hiddenClass = 'product-details__section--hidden';

    const visibleContentSections = this.contentSections.filter(
      (section) => !section.classList.contains(hiddenClass)
    );

    if (visibleContentSections && visibleContentSections.length > 0) {
      this.alternateTextDirection(visibleContentSections);
      this.alternateBackground(visibleContentSections);
    }

    this.toggleHighlightArticle();
  }

  alternateTextDirection(sections) {
    const rightClass = 'product-content-block--text-block-right';
    const leftClass = 'product-content-block--text-block-left';

    sections.forEach((section, index) => {
      section.classList.remove(rightClass);
      section.classList.remove(leftClass);
      section.classList.add(index % 2 ? rightClass : leftClass);
    });
  }

  alternateBackground(sections) {
    const coloredBgClass = 'product-details__section--colored-bg';
    const transparentBgClass = 'product-details__section--transparent-bg';
    const separatorClass = 'product-details__section--with-separator';

    sections.forEach((section, index) => {
      section.classList.remove(coloredBgClass);
      section.classList.remove(transparentBgClass);
      section.classList.remove(separatorClass);

      // every second section should have bg color and the last section should always have bg color
      if (!(index % 2) || index === sections.length - 1) {
        section.classList.add(coloredBgClass);
      } else {
        section.classList.add(transparentBgClass);
      }
    });

    if (!(sections.length % 2)) {
      sections[sections.length - 1].classList.add(separatorClass);
    }
  }

  toggleHighlightArticle() {
    const imageWrapper = this.mainElement.querySelector('.product-detailed-page__image-wrapper');
    if (imageWrapper) {
      if (productStore.productDetails.highlightArticle) {
        imageWrapper.classList.add('product-detailed-page__image-wrapper--highlight');
      } else {
        imageWrapper.classList.remove('product-detailed-page__image-wrapper--highlight');
      }
    }
  }
}
